export const types = {
  LIST_REFERRAL: 'LIST_REFERRAL',
  GET_LIST_REFERRER: 'GET_LIST_REFERRER',
  ALL_REFERRAL_INFO:'ALL_REFERRAL_INFO',
  GET_STATISTICS:'GET_STATISTICS',
  GET_PERCENT:'GET_PERCENT',
};